import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { BreadcrumbItem } from "@/types/breadcrumbs"
import {
  createBreadcrumbs,
  showBreadcrumbsNavigation,
} from "@/utils/breadcrumbs/breadcrumbs"
import { useMemo } from "react"
import { useLocation } from "react-router"

const BREADCRUMB_PAGES = ["upload", "questions", "answers", "preview"]
const BREADCRUMB_PAGES_SHOW_NAV = [
  "questions",
  "answers",
  "excel-answers",
  "excel-questions",
  "qm-questions",
  "qm-answers",
  "pdf-questions",
  "pdf-answers",
]

interface UseBreadcrumbsReturn {
  breadcrumbs: BreadcrumbItem[]
  showBreadcrumbs: boolean
}

export const useBreadcrumbs = (): UseBreadcrumbsReturn => {
  const { translate } = useTranslation()
  const location = useLocation()

  const showBreadcrumbs = showBreadcrumbsNavigation(
    location.pathname,
    BREADCRUMB_PAGES_SHOW_NAV,
  )

  const breadcrumbs = useMemo(() => {
    if (!showBreadcrumbs) return []

    const baseBreadcrumbs = createBreadcrumbs(
      location.pathname,
      BREADCRUMB_PAGES,
      translate,
    )

    return baseBreadcrumbs.map((breadcrumb) => {
      return {
        ...breadcrumb,
      }
    })
  }, [showBreadcrumbs, location.pathname, translate])

  return {
    breadcrumbs,
    showBreadcrumbs,
  }
}
